import { EXECUTE_TYPE_TOAST } from '@/common/converter/const'

/**
 * preExecute 의 type 이 toast 인 경우
 * toast text 를 반환
 * @param {object} preExecute {type, value}
 * @returns {string} toast_text
 */
export const getPreExecuteToastText = (preExecute = {}) => {
  const { type, value = '' } = preExecute
  if (type === EXECUTE_TYPE_TOAST) {
    return value
  }
  return ''
}
